import { gate } from 'hub-http/gates';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddIcon } from 'foundations-assets';
import { Section } from 'foundations-components/transitional/components/Section';
import { H5 } from 'UIComponents/elements/headings';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Image } from 'foundations-components/transitional/components/Image';
import { useChosenApps } from 'setup-guide-api/dataFetchingClient/queries/integrations';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { useHasAppInstallAccess } from 'setup-guide-components/hooks/auth';
import { useIsUngated } from '../../hooks/auth';
import { useIntegrationsSidePanel, useSelectedIntegration } from '../../hooks/integrations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BUTTON_SPACING_X = 8;
const MAX_APPS_DISPLAYED = 3;
const SetupGuideNavIntegrationsWidget = () => {
  const isUngated = useIsUngated(gate('GrowthOnboardingSetup:ConnectToolStackUpfront'));
  const hasAppInstallAccess = useHasAppInstallAccess();
  const chosenApps = useChosenApps();
  const {
    showSidePanel
  } = useIntegrationsSidePanel();
  const [, setSelectedIntegration] = useSelectedIntegration();
  const {
    trackSectionView,
    trackUserInteraction
  } = useTracker();
  const shouldSeeIntegrationsWidget = isUngated && hasAppInstallAccess && chosenApps.length > 0;
  useEffect(() => {
    // Only track the view of the integrations widget if we render this component.
    // If the user does not have this gate or has no chosen apps, we should not track the view.
    if (shouldSeeIntegrationsWidget) {
      trackSectionView('integrations nav widget', '', chosenApps.map(app => app.name));
    }
  }, [shouldSeeIntegrationsWidget, trackSectionView, chosenApps]);

  // If the user has no chosen apps remaining, we should not show the widget
  if (!shouldSeeIntegrationsWidget) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.integrations.navWidgetTitle"
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      gap: BUTTON_SPACING_X,
      children: [chosenApps.slice(0, MAX_APPS_DISPLAYED).map(app => /*#__PURE__*/_jsx(IconButton, {
        marginInline: "0",
        onClick: () => {
          setSelectedIntegration(app.slug);
          showSidePanel();
          trackUserInteraction('click integrations nav widget app', app.name);
        },
        padding: "200",
        children: /*#__PURE__*/_jsx(Image, {
          alt: app.name,
          src: app.iconUrl
        })
      }, app.id)), /*#__PURE__*/_jsx(IconButton, {
        marginInline: "0",
        onClick: () => {
          setSelectedIntegration(null);
          showSidePanel();
          trackUserInteraction('click integrations nav widget add button');
        },
        children: /*#__PURE__*/_jsx(AddIcon, {})
      })]
    })]
  });
};
export default SetupGuideNavIntegrationsWidget;